import { aviary } from "@aviary";
import { sharedUS } from "@shared/locales";

import { common } from "./common";
import { error } from "./error";
import { intake } from "./intake";
import { linkNotification } from "./linkNotification";
import { officeSignUp } from "./officeSignUp";
import { patientRxAuth } from "./patientRxAuth";
import { practitionerSignUp } from "./practitionerSignUp";
import { signIn } from "./signIn";

export const US = {
  aviary,
  common,
  error,
  officeSignUp,
  patientRxAuth,
  practitionerSignUp,
  linkNotification,
  signIn,
  intake,
  ...sharedUS,
};
